import once from 'lodash/once'

export type Suspendable<T> = {
  spawn?: () => Suspendable<T>
  suspend: () => T
}

export const suspendAll = <const Arr extends Suspendable<any>[]>(arr: Arr) => {
  for (const a of arr) {
    a.spawn?.()
  }
  return arr.map(a => a.suspend()) as { [K in keyof Arr]: ReturnType<Arr[K]['suspend']> }
}

export const mergeSuspends = <const Arr extends Suspendable<any>[]>(arr: Arr): Suspendable<ReturnType<typeof suspendAll<Arr>>> => {
  return { suspend: () => suspendAll(arr) }
}

export const mapSuspendable = <T, R>(s: Suspendable<T>, mapper: (value: T) => R): Suspendable<R> => {
  return { suspend: () => mapper(s.suspend()) }
}

export const createSuspendable = <T>(val: () => T): Suspendable<T> => {
  return { suspend: once(() => val()) }
}
